const BENEFITS_MANDATORY_OPTIONS = [
  {
    label: "Country",
    value: "country",
    sort: true,
    sortValue: "country",
  },
  {
    label: "Type",
    value: "type",
    sort: true,
    sortValue: "type",
  },
  {
    label: "Value",
    value: "value",
    sort: true,
    sortValue: "value",
  },
  {
    label: "Created By",
    value: "createdByName",
    sort: true,
    sortValue: "createdByName",
  },
  {
    label: "Created At",
    value: "createdAt",
    sort: true,
    sortValue: "created_at",
  },
  {
    label: "Updated At",
    value: "updatedAt",
    sort: true,
    sortValue: "updated_at",
  },
];

export { BENEFITS_MANDATORY_OPTIONS };
